export default __webpack_public_path__ + "static/media/logo-slim.b5d27c8c.jpg";